import {
  ReportTooltipTemplateContext,
  ReportsTranslations,
  DatasetBase,
  ReportTooltipNormalizedParams,
} from '@core/reports-types';
import { valueFormatter } from '@core/utils-legacy';

import { hasConversionData } from './shared';

const getParamValue = (param: ReportTooltipNormalizedParams[0]) => {
  const data = Array.isArray(param.data) ? param.data : [param.data];
  return <string | number>data[param.seriesIndex! + 1];
};

const withConversion = (
  dataset: DatasetBase,
  translations: ReportsTranslations,
  params: ReportTooltipNormalizedParams,
) => ({
  footerPrimaryText: dataset.metric.name,

  footerSecondaryText: `${dataset.getDataAt([params[0].dataIndex + 1, 3])}`,
  headerText: dataset.getCategoryNameById(params[0].name),
  items: params.map(param => ({
    label: param.seriesName!,
    value: valueFormatter(
      getParamValue(param),
      {
        unitType: dataset.metric.unitType,
        unitPrecision: dataset?.meta?.unitPrecision ?? dataset.metric.unitPrecision,
      },
      translations.i18n,
    ),
    color: <string>param.color,
    fadeOut: false,
  })),
});

const withoutConversion = (
  dataset: DatasetBase,
  translations: ReportsTranslations,
  params: ReportTooltipNormalizedParams,
) => {
  const data = Array.isArray(params[0].data) ? params[0].data : [params[0].data];

  return {
    footerPrimaryText: undefined,
    footerSecondaryText: undefined,
    headerText: dataset.metric.dataLabel,
    items: [
      {
        label: dataset.getCategoryNameById(params[0].name),
        value: valueFormatter(
          <string | number>data[params[0].seriesIndex! + 1],
          {
            unitType: dataset.metric.unitType,
            unitPrecision: dataset?.meta?.unitPrecision ?? dataset.metric.unitPrecision,
          },
          translations.i18n,
        ),
        color: <string>params[0].color,
      },
    ],
  };
};

export const funnelTooltipContextFactory = (
  dataset: DatasetBase,
  translations: ReportsTranslations,
  params: ReportTooltipNormalizedParams,
): ReportTooltipTemplateContext =>
  hasConversionData(dataset.metric.metric)
    ? withConversion(dataset, translations, params)
    : withoutConversion(dataset, translations, params);
